(function($) {
  window.Edu = window.Edu || {};

  /**** Parse querystring for easy use in other javascript files ****/
  window.Edu.queryString = {};
  document.location.search.replace(/(^\?)/, '').split('&').map(function (keyValue) {
    keyValue = keyValue.split('=');
    if (keyValue[0] && keyValue[1]) {
      window.Edu.queryString[keyValue[0]] = keyValue[1];
    }
  });

  /** This will launch the kidframe in a separate browser window */
  window.Edu.launchWebGame = function(href, callback) {
    if (!href) return;

    var h = (screen.availHeight) ? screen.availHeight : screen.height,
        w = (screen.availWidth) ? screen.availWidth : screen.width;
    h = (h > 1250) ? 1250 : h;
    w = (w > 1920) ? 1920 : w;
    h = h - 14;
    w = w - 14;
    gameWindow = window.open(href, 'gameswindow', 'scrollbars=no,menubar=no,location=no,status=no,toolbar=no,outerHeight='+h+',height='+h+',outerWidth='+w+',width='+w+',fullscreen=yes,left=0,top=0,resizable=yes');
    gameWindow.focus();

    if (callback) callback();
  };

  /**** Analytics Tracking ****/
  window.Edu.trackEvent = function(name, segment_data, ga_fields) {
    if(ga_fields && ga_fields.eventCategory && ga_fields.eventAction) {
      // GA
      (window.ga || function(){})('send','event',ga_fields);

      // GTM
      (window.dataLayer || []).push({
        event: 'GAEvent',
        eventCategory: ga_fields.eventCategory,
        eventAction: ga_fields.eventAction,
        eventLabel: ga_fields.eventLabel,
        eventValue: ga_fields.eventValue
      });
    }

    // Segment
    if(name && window.analytics && window.analytics.track) {
      // TODO: if we switch GA to segment, merge in ga fields
      window.analytics.track(name, segment_data);
    }
  };
  window.Edu.trackProductView = function(data) {
    var sku = data.sku;
    if(!sku) return;
    var name = data.name || sku;
    var category = data.category || null;
    var price = data.price || 0;

    // GA
    if(window.ga) {
      window.ga('require', 'ec', 'ec.js');
      window.ga('ec:addProduct', {
        id: sku,
        name: name,
        category: category,
        brand: "Education.com",
        price: price
      });
      window.ga('ec:setAction', 'detail');
      window.ga('send', 'event', 'ecommerce', 'detail', sku, {'nonInteraction': 1});
    }

    // GTM
    (window.dataLayer || []).push({
      ecommerce: {
        detail: {
          actionField: { },
          products: [{
            id: sku,
            name: name,
            category: category,
            brand: "Education.com",
            price: price
          }]
        }
      }
    });
    (window.dataLayer || []).push({
      event: 'GAEvent',
      eventCategory: 'ecommerce',
      eventAction: 'detail',
      eventLabel: sku
    });

    // Segment
    if(window.analytics && window.analytics.track) {
      window.analytics.track('Viewed Product',{
        id: sku,
        sku: sku,
        name: name,
        price: price,
        category: category
      });
    }
  };
  window.Edu.setCheckoutStepInfo = function(data) {
    var sku = data.sku;
    if(!sku) return;
    var name = data.name || sku;
    var category = data.category || null;
    var price = data.price || 0;
    var step_data = step_data || {};

    // GA
    if(window.ga) {
      window.ga('require', 'ec', 'ec.js');
      window.ga('ec:addProduct', {
        id: sku,
        name: name,
        category: category,
        brand: "Education.com",
        price: price,
        quantity: 1
      });
      window.ga('ec:setAction', 'checkout', step_data);
    }

    // GTM
    (window.dataLayer || []).push({
      event: 'checkout',
      ecommerce: {
        checkout: {
          actionField: step_data,
          products: [{
            id: sku,
            name: name,
            category: category,
            brand: "Education.com",
            price: price,
            quantity: 1
          }]
        }
      }
    });
  };
  window.Edu.trackPurchase = function(data) {
    if(!data.sku || !data.orderId) return;

    var sku = data.sku;
    var name = data.name || sku;
    var price = (data.price || 0)*1;
    var category = data.category || null;
    var orderId = data.orderId;
    var discount = (data.discount || 0)*1;
    var ltv = (data.ltv || (price - discount))*1;
    var coupon = data.coupon || "";
    var currency = data.currency || "USD";
    var revenue = (price - discount)*1;

    // GA
    if(window.ga) {
      window.ga('require', 'ec', 'ec.js');
      window.ga('ec:addProduct', {
        id: sku,
        name: name,
        category: category,
        brand: "Education.com",
        price: revenue.toFixed(2),
        coupon: coupon,
        quantity: 1
      });
      window.ga('ec:setAction', 'purchase', {
        id: orderId,
        revenue: revenue.toFixed(2),
        coupon: coupon
      });
      window.ga('send', 'event', 'ecommerce', 'purchase', sku, Math.round(ltv), {'nonInteraction': 1});
    }

    // GTM
    (window.dataLayer || []).push({
      ecommerce: {
        purchase: {
          actionField: {
            id: orderId,
            revenue: revenue.toFixed(2),
            coupon: coupon
          },
          products: [{
            id: sku,
            name: name,
            category: category,
            brand: "Education.com",
            price: revenue.toFixed(2),
            coupon: coupon,
            quantity: 1
          }]
        }
      }
    });
    (window.dataLayer || []).push({
      event: 'GAEvent',
      eventCategory: 'ecommerce',
      eventAction: 'purchase',
      eventContentType: category,
      eventContentIds: "'" + sku + "'",
      eventLabel: sku,
      eventValue: Math.round(ltv)
    });

    // Segment
    if(window.analytics && window.analytics.track) {
      window.analytics.track('Completed Order',{
        orderId: orderId,
        total: price,
        revenue: revenue,
        ltv: ltv,
        shipping: 0,
        tax: 0,
        discount: discount,
        coupon: coupon,
        currency: currency,
        products: [
          {
            id: sku,
            sku: sku,
            name: name,
            price: price,
            category: category,
            quantity: 1
          }
        ]
      });
    }
  };

  /**** Special `debugLog` querystring that sends all javascript logs and errors to our server ****/
  if(window.location.href.match(/[?&]debugLog($|[&])/)) {
    var log = function(obj) {
      obj.url = window.location.href;
      $.post('/api/debugLog',obj);
    };

    // global js error listener
    var oldOnError = window.onerror;
    window.onerror = function (msg, url, lineNo, columnNo, error) {
      var string = msg.toLowerCase();
      var substring = "script error";
      if (string.indexOf(substring) > -1){
        // Ignore "script error" because we can't get any details out of it
      } else {
        log({
          type: 'onerror',
          message: msg,
          source: url,
          lineNo: lineNo,
          columnNo: columnNo,
          error: JSON.stringify(error)
        });
      }

      // This is a transparent intercept so continue calling the previous listener
      if(oldOnError && oldOnError.apply) {
        oldOnError.apply(window, [msg, url, lineNo, columnNo, error]);
      }
    };

    // Make sure console.log and console.error are defined
    if(!window.console || !window.console.log) {
      window.console = {
        log: function() {},
        error: function() {}
      };
    }

    // Intercept console.log calls
    var oldConsoleLog = window.console.log;
    window.console.log = function() {
      var args = Array.prototype.slice.call(arguments);
      log({
        type: 'console.log',
        args: JSON.stringify(args)
      });

      oldConsoleLog.apply(window.console, args);
    };


    // Intercept console.error calls
    var oldConsoleError = window.console.error;
    window.console.error = function() {
      var args = Array.prototype.slice.call(arguments);
      log({
        type: 'console.error',
        args: JSON.stringify(args)
      });

      oldConsoleError.apply(window.console, args);
    };
  }

  /**** Semi-transparent page overlay (used behind modals) ****/
  window.Edu.overlay = $("<div id='modal-overlay'></div>").on('click',function() {
    // Don't close a modal if it's still opening
    if(window.Edu.modal_open_timer) return;

    /** Exception: if this modal is the additional-info-request modal; refresh the page instead of closing it */
    var modalOpen = $('.modal.open');
    if (modalOpen[0] && modalOpen[0].id === 'additional-info-request') {
      window.location = window.location;
    }

    $('body').css('overflow', 'visible');
    modalOpen.removeClass('open');
    $('.search-filter.open').removeClass('open');
    $(this).fadeOut(500);
    $(document).trigger('modalClosed');

  });
  $(document).ready(function() {
    window.Edu.overlay.appendTo(document.body);
  });

  /**** Pop-up Modals ****/
  $.fn.modal = function(options) {
    // Instantiation
    if(!this.data('modal')) {
      var self = this;
      options = options || {};
      this.data('modal',options);
      options.el = self;

      options.show = function() {
        // Close all open modals
        $('.modal.open').removeClass('open');

        // Don't allow closing a modal until it's finished opening
        // This solves the issue of a double-click opening and then immediately closing the modal
        window.clearTimeout(window.Edu.modal_open_timer);
        window.Edu.modal_open_timer = window.setTimeout(function() {
          window.Edu.modal_open_timer = 0;

          // If this is mobile, don't auto-focus an input (causes keyboard to popup)
          if(navigator.userAgent.match(/(Mobile|Tablet)/i)) {
            return;
          }

          //Focus on the first empty input.
          var numberOfInputFieldsToCheck = 2;
          var focusedInput = false;
          var inputElements = $('input[type=text]:visible, input[type=email]:visible, ' +
          'input[type=password]:visible', self);

          for (var i = 0; i < inputElements.length; i++) {
            if (i < numberOfInputFieldsToCheck && !$(inputElements[i]).val()) {
              $(inputElements[i]).focus();
              focusedInput = true;
              break;
            }
          }

          //If all inputs are filled, focus on the first one.
          if (!focusedInput) {
            $(inputElements[0]).focus();
          }
        },500);

        // Show modal
        window.Edu.overlay.fadeIn(500);
        self.addClass('open');

        if(this.onOpen) this.onOpen.call(this);
      };
      options.hide = function() {
        // Close all modals and hide overlay
        $('body').css('overflow', 'visible');
        $('.modal.open').removeClass('open');
        window.Edu.overlay.fadeOut(500);
        if(this.onClose) this.onClose.call(this);
      };

      options.disabled = options.disabled || false;
      options.showOverlay = options.showOverlay || function () {
        options.el.addClass('has_overlay');
        options.disabled = true;
        $('.icon-cancel, .icon-cancel-light, .close', options.el).hide();
      };
      options.hideOverlay = options.hideOverlay || function () {
        options.el.removeClass('has_overlay');
        options.disabled = false;
        $('.icon-cancel, .icon-cancel-light, .close', options.el).show();
      };

      // Close icon and links
      $('.icon-cancel, .icon-cancel-light, .close',this).on('click',function() {
        options.hide();
        $(document).trigger('modalClosed');
        return false;
      });
      // Close when the space below the modal is clicked
      this.on('click',function(e) {
        if(e.target && $(e.target).hasClass('modal')) {
          options.hide();
        }
      });
      // Listen for form submits
      if(options.submit) {
        $('form',this).on('submit',function(e) {
          e.preventDefault();
          self.modal('submit');
        });
      }
      // Show modal when trigger is clicked
      if(options.trigger) {
        options.trigger.on('click',function() {
          options.show();
          return false;
        });
      }

      // Initialization
      if(options.init) options.init();
    }
    else {
      // Call method
      var data = this.data('modal');
      if(data[options] && $.isFunction(data[options])) {
        var result = data[options].apply(data,Array.prototype.slice.call(arguments,1));
        if(result!==undefined) return result;
      }
      // Unknown
      else {
        console.error("Trying to call unknown modal method",options);
      }
    }

    return this;
  };
  window.Edu.createModal = function(html, options) {
    var container = $("<div class='modal'></div>").appendTo($(document.body));
    container.append('<i class="icon-cancel"></i>');
    $("<div class='modal-content'></div>").html(html).appendTo(container);
    container.modal(options);

    return container;
  };

  window.Edu.cache = {prefix:"educ-"};

  // API helper methods with runtime cache
  window.Edu.api = {
    invalidateStudentsCache: function() {
      if(!window.Edu.memberId) return;
      window.Edu.api._invalidate('api.getStudents.v1.'+window.Edu.memberId);
    },
    getStudents: function(callback, nocache) {
      return new Promise(function(resolve, reject) {
          var cb = function(err, resp) {
              if(callback) {
                  callback(err,resp);
              }

              if(err) reject(Error(err));
              else resolve(resp);
          };

          if(!window.Edu.memberId) {
              cb('No member id');
              return;
          }

          var cache_key = 'api.getStudents.v1.'+window.Edu.memberId;
          var api_process = function(resp) {
              return resp.children;
          };
          window.Edu.api._get(cache_key,'/api/children',{},api_process,cb,nocache);
      });
    },
    invalidateAllGroupsCache: function() {
        if(!window.Edu.memberId) return;
        window.Edu.api._invalidate('api.getAllGroups.v1.'+window.Edu.memberId);
    },
    getAllGroups: function(nocache) {
      return new Promise(function(resolve, reject) {
        var cb = function(err, resp) {
          if(err) reject(Error(err));
          else resolve(resp);
        };

        if(!window.Edu.memberId) {
          cb("No member id");
          return;
        }

        var cache_key = 'api.getAllGroups.v1.'+window.Edu.memberId;
        var api_process = function(resp) {
          return resp.groups;
        };
        window.Edu.api._get(cache_key,'/api/children/groups',{},api_process,cb,nocache);
      });
    },
    invalidateStudentGroupsCache: function() {
      if(!window.Edu.memberId) return;
      window.Edu.api._invalidate('api.getStudentGroups.v1.'+window.Edu.memberId);
    },
    getStudentGroups: function(callback, nocache) {
        return new Promise(function(resolve, reject) {
            var cb = function(err, resp) {
                if(callback) {
                    callback(err,resp);
                }

                if(err) reject(Error(err));
                else resolve(resp);
            };

            if(!window.Edu.memberId) {
                cb('No member id');
                return;
            }

            var cache_key = 'api.getStudentGroups.v1.'+window.Edu.memberId;
            var api_process = function(resp) {
                return resp.groups;
            };
            window.Edu.api._get(cache_key,'/api/children/groups',{},api_process,cb,nocache);
        });
    },
    invalidateAssignmentsCache: function() {
      if(!window.Edu.memberId) return;
      window.Edu.api._invalidate('api.getAssignments.v1.'+window.Edu.memberId);
    },
    invalidateSingleAssignmentCache: function(assignmentId) {
        if(!window.Edu.memberId) return;
        window.Edu.api._invalidate('api.getSingleAssignment.v1.'+ assignmentId);
    },
    getSingleAssignment: function(assignmentId, callback, nocache) {
        return new Promise(function(resolve, reject) {
            var cb = function(err, resp) {
                if(callback) {
                    callback(err,resp);
                }

                if(err) reject(Error(err));
                else resolve(resp);
            };

            if(!window.Edu.memberId) {
                cb('No member id');
                return;
            }

            if(!assignmentId) {
                cb('No assigmentId');
                return;
            }

            var cache_key = 'api.getSingleAssignment.v1.'+assignmentId;
            var url = '/api/assignments/'+assignmentId;
            var api_process = function(resp) {
              return resp;
            };
            window.Edu.api._get(cache_key,url,{},api_process,cb,nocache);
        });
    },
    getAssignmentsCacheKey: function() {
      return 'api.getAssignments.v1.' + window.Edu.memberId;
    },
    getAssignments: function(callback, nocache, getFullItemDetails) {
        return new Promise(function(resolve, reject) {
            var cb = function(err, resp) {
                if(callback) {
                    callback(err,resp);
                }

                if(err) reject(Error(err));
                else resolve(resp);
            };

            if(!window.Edu.memberId) {
                cb('No member id');
                return;
            }

            var cache_key = window.Edu.api.getAssignmentsCacheKey();
            var url = '/api/assignments/member/'+window.Edu.memberId;
            var data = {
                page:1,
                limit:100,
                sortType:'dateCreated',
                sortDirection:-1,
                getFullItemDetails: getFullItemDetails ? '1' : ''
            };
            var api_process = function(resp) {
                return resp.assignments;
            };
            window.Edu.api._get(cache_key,url,data,api_process,cb,nocache);
        });
    },
    _invalidate: function(cache_key) {
      if (!cache_key) return;

      // If we're currently fetching, no need to invalidate
      if(window.Edu.cache[cache_key] === 'fetching') {
        return;
      }

      // Invalidate runtime cache
      window.Edu.cache[cache_key] = null;

      // Invalidate local storage cache
      window.localStorage.removeItem(window.Edu.cache.prefix+cache_key);
    },
    _get: function(cache_key, url, data, api_process, callback, nocache) {
      if (cache_key) {
        // Runtime Cache
        if(!nocache && window.Edu.cache[cache_key]) {
            // Another process is currently fetching groups, try again in 200ms
            if(window.Edu.cache[cache_key] === 'fetching') {
                window.setTimeout(function() {
                    window.Edu.api._get(cache_key, url, data, api_process, callback, nocache);
                },200);
                return;
            }

            callback(null, window.Edu.cache[cache_key]);
            return;
        } else {
            window.Edu.cache[cache_key] = 'fetching';
        }
      }

      // Persistent cache disabled via querystring
      if(window.location.href.match(/\bnocache\b/)) {
        nocache = true;
      }

      // Local storage
      if(!nocache) {
        var cached = window.localStorage.getItem(window.Edu.cache.prefix+cache_key);
        if(cached) {
          var decoded = JSON.parse(cached);
          // Make sure cached data hasn't expired yet
          if(decoded && decoded.data && decoded.expires && decoded.expires > (new Date()).getTime()) {
            // Runtime cache
            window.Edu.cache[cache_key] = decoded.data;

            callback(null, window.Edu.cache[cache_key]);
            return;
          }
          else {
            // Either corrupted data or expired, remove from localstorage
            window.localStorage.removeItem(window.Edu.cache.prefix+cache_key);
          }
        }
      }

      // API
      $.get(url, data, function(results) {
        if(results) {
          // Process results into proper format for return
          if(api_process) {
            try {
              results = api_process(results);
            }
            catch(e) {
              callback(e);
              return;
            }
          }

          if (cache_key) {
            // Runtime cache
            window.Edu.cache[cache_key] = results;

            // Local storage cache
            try {
              window.localStorage.setItem(window.Edu.cache.prefix+cache_key, JSON.stringify({
                data: results,
                timeCached: ((new Date()).getTime())/1000,
                // Cache for 20 minutes
                expires: (new Date()).getTime() + 20*60*1000
              }));
            }
            catch(e) {}
          }
          callback(null, results);
        }
        else {
          callback('Failed to load '+cache_key);
        }
      }).fail(function() {
        callback('Failed to load '+cache_key);
      });
    }
  };

  // Auto-invalidate caches based on ajax calls
  $(document).ajaxSend(function(event,xhr,settings) {
    // Catch all requests that modify data
    if(settings && settings.type && ['POST','PUT','PATCH','DELETE'].indexOf(settings.type.toUpperCase()) >= 0) {
      // Changing a student or group
      if(settings.url.match(/\/api\/child/)) {
        window.Edu.api.invalidateStudentsCache();
        window.Edu.api.invalidateStudentGroupsCache();
      }
      else if(settings.url.match(/\/games\/request\/user\//)) {
        window.Edu.api.invalidateStudentsCache();
        window.Edu.api.invalidateStudentGroupsCache();
      }
      // Changing an assignment
      else if(settings.url.match(/\/api\/assignment/)) {
        window.Edu.api.invalidateAssignmentsCache();
      }
    }
  });
  // Periodically flush all expired cache items from localStorage
  if(Math.random() < 0.1) {
    (function () {
      var key, value;
      var prefixRegExp = new RegExp('^' + window.Edu.cache.prefix);
      var now = (new Date()).getTime();
      // Need to count down since removeItem changes the indexes
      for (var i = localStorage.length - 1; i >= 0; --i) {
        key = localStorage.key(i);
        if (key && key.match(prefixRegExp)) {
          value = localStorage.getItem(key);
          if (value) {
            value = JSON.parse(value);
            if (!value || !value.expires || !value.data || value.expires < now) {
              localStorage.removeItem(key);
            }
          }
        }
      }
    })();
  }

  /**** Ads Gutter ****/
  $(document).ready(function() {
    var adsGutter = $('.ads-gutter');
    if(adsGutter.find('.ad-container-gutter:visible').length) {
      $(document.body).addClass('with-ad-gutter');
      if (adsGutter.find('.gutter-bottom').length > 0) {
        adsGutter.height(2200);
      }
    }
    else {
      $(document.body).removeClass('with-ad-gutter');
    }
  });
  // `window.Edu.setupAdGutter` should be called immediately after adding 
  // the ad gutter div to the page to prevent the page from jumping
  // This is just a fallback in case that step is forgotten.
  $(document).ready(window.Edu.setupAdGutter);

  /**** Lazy load content as it comes into view ****/
  $.fn.lazyload = function(options) {
    options = options || {};
    var scrollEl = $(options.scrollEl || window),
      els=[],
      current,
      el,
      i,
      num,
      onscroll,
      getOffset = function(el) {return el.offset().top - (el.attr('data-lazyload-buffer') || options.buffer || 150)};

    // Lazyload a class
    $('[data-lazyload-class]',this).each(function() {
      el = $(this);
      els.push({
        el: el,
        offset: getOffset(el),
        klass: el.attr('data-lazyload-class') || options["class"] || 'lazyloaded'
      });
      //console.log(el,getOffset(el));
    });
    // Lazyload src
    $('[data-lazyload-src]',this).each(function() {
      el = $(this);
      i = getOffset(el);
      if(!options.allowNegativeOffset && i < -200) return;
      els.push({
        el: el,
        offset: i,
        src: el.attr('data-lazyload-src')
      });
      //console.log(el,getOffset(el));
    });

    els.sort(function(a,b) {
      return a.offset - b.offset;
    });
    num = els.length;

    if(els.length) {
      onscroll = function() {
        current = scrollEl.scrollTop() + scrollEl.height();
        //console.log(current);
        for(i=0;i<num;i++) {
          el = els[i];
          if(current < el.offset) break;
          //console.log('loading',el.el.get(0).className);
          if(el.klass) el.el.addClass(el.klass);
          if(el.src) el.el.attr('src',el.src);
        }
        if(i) {
          els.splice(0,i);
          num = els.length;
          if(!els.length) scrollEl.off('scroll',onscroll);
        }
      };
      scrollEl.on('scroll',onscroll);

      // Initial
      onscroll();
    }

    return this;
  };
  // Auto lazy load in main content area.
  $(document).ready(function() {
    window.setTimeout(function() {
      $('main').lazyload();
    },500);
  });


  /**** Detect touch support ****/
  //window.isTouch = (('ontouchstart' in window) || window.DocumentTouch && document instanceof DocumentTouch);
  window.isTouch = false;
  $(document).ready(function() {
    $(document.body).one('touchstart',function(e) {
      window.isTouch = true;
      $(document.body).addClass('touch');
    });
  });

  /**** Star Ratings ****/
  $.fn.starRating = function(options) {
    options = options || {};

    var update = function(container,rating,count) {
      rating = rating*1;
      count = count*1;

      // Update rating text
      if(count) {
        $('.rating-info', container).text(rating.toFixed(1)+' based on '+count+' rating'+(count!=1?'s':''));
      }
      else {
        $('.rating-info', container).html('<span>no ratings yet</span>');
      }

      // Update stars
      $('.star',container).each(function(i,el) {
        if(rating <= i) {
          $('.full',el).css('width',0);
        }
        else if(rating >= i+1) {
          $('.full',el).css('width','100%');
        }
        else {
          $('.full',el).css('width',(rating-i).toFixed(4)*100+'%');
        }
      });
    };
    var signup_form = $("#signup-form");
    return this.each(function() {
      var container = $(this);
      var uid = container.attr('data-uniqueid');
      var type = container.attr('data-ratingtype');
      var content_type = container.attr('data-contenttype');
      container.on('click','.star',function() {
        var rating = $(this).attr('data-rating');

        if(container.attr('data-showlogin') !== undefined) { //user not logged in and require login set
          if (!signup_form.length) return;
          signup_form.modal('show');
        } else {
          $.post(window.location.href, {
            uniqueID: uid,
            type: type,
            contentType: content_type,
            __json: "AddRating",
            rating: rating,
            newStarRating: 1
          }, function (response) {
            //console.log(response);
            if (response && response.rating) {
                var ratingValue = response.rating.avg;
                if(container.attr('data-hideratingsaverage') !== undefined) {
                    ratingValue = rating;
                }
                update(container, ratingValue, response.rating.count);
            }
          });
        }
      });
    });
  };
  $(document).ready(function() {
    $('.star-rating.interactive').starRating();
    $('.star-rating-page.interactive').starRating();
  });

  /**** Refresh Ads ****/
  window.Edu.refreshAds = function(time) {
    time = time || 5;

    window.last_ad_refresh = window.last_ad_refresh || false;

    var now = new Date();

    //only refresh ads at most once every 15 seconds
    if (window.last_ad_refresh && (now.getTime() - window.last_ad_refresh.getTime()) < time * 1000) {
      return;
    }
    window.last_ad_refresh = now;

    // refresh bids/ads for prebid
    if (!window.prebid_script_loaded) {
      if ('googletag' in window && 'refreshables' in window.googletag) {
          window.googletag.pubads().refresh(window.googletag.refreshables);
      }
    } else {
      // Amazon header bidding
      if ('apstag' in window) {
        if ('a9Slots' in window && window.a9Slots.length > 0) {
          /* A9 Request Bids */
          window.a9BidsBack = false;
          window.apstag.fetchBids({
              slots: window.a9Slots,
              timeout: window.PREBID_TIMEOUT
          }, function(bids) {
            window.a9BidsBack = true;
          })
        }
      }
      // Prebid header bidding
      if ('pbjs' in window) {
          window.pbjs.que.push(function() {
              window.pbjs.requestBids({
                  timeout: window.PREBID_TIMEOUT,
                  bidsBackHandler: function() {
                    /* A9 Set Bids */
                    if (window.a9BidsBack) window.apstag.setDisplayBids();
                    window.pbjs.setTargetingForGPTAsync();
                    window.googletag.pubads().refresh();
                  }
              });
          });
      }
    }
  };
  $(window).on('refreshAds', function () {
    window.Edu.refreshAds();
  });

  /**** Paywall Functions ****/
  window.Edu.getLocalStorageRemainingCredits = function () {
    try {
      if (window.localStorage) {
        var creditsRemaining = window.localStorage.getItem('creditsRemaining');
        //is this a number
        if (!isNaN(parseFloat(creditsRemaining)) && isFinite(creditsRemaining)
          && creditsRemaining >= 0) {
          return creditsRemaining;
        }
        else {
          return 1;
        }
      }
    }
    catch(e) {}
    return 0;
  };
  window.Edu.decrementLocalStoragePaywallCount = function () {
    if (window.localStorage) {
      var creditsRemaining = window.Edu.getLocalStorageRemainingCredits();

      if (creditsRemaining > 0) {
        try {
          window.localStorage.setItem('creditsRemaining', creditsRemaining - 1);
        }
        catch (e) {}
      }
    }
  };

  /**** Fixed Container While Scrolling ****/
  $(document).ready(function() {
    var raf = window.requestAnimationFrame || function(callback) {callback();};

    function Fixtop (el) {
      this.el = el;
      this.startingPosition = 0;
      this.parent = null;
      this.offsetParent = el.parent();
      this.isFixed = false;

      this.init = function () {
        if(this.el.attr('data-parent')) {
          this.parent = $(this.el.attr('data-parent'));
          this.startingPosition = this.el.offset().top;
        }

        this.scroll();
      };

      this.fixToTop = function () {
        if(this.isFixed) return;
        this.isFixed = true;
        this.el.css({
          position: 'fixed',
          top: 0,
          bottom: ''
        });
      };

      this.unfixToTop = function () {
        if(!this.isFixed) return;
        this.isFixed = false;
        this.el.css({
          position: '',
          left: '',
          top: '',
          bottom: ''
        });
      };

      var doc = $(document);
      var adHeight, scrollHeight, top;

      this.scroll = function () {
        adHeight = this.el.height();
        scrollHeight = doc.scrollTop();

        // We're below the scroll window
        if ((this.parent.offset().top + this.parent.height()) <= scrollHeight + adHeight) {
          this.unfixToTop();
          top = this.parent.offset().top + this.parent.height() - adHeight;

          // The fixed element's parent is not static, remove the extra top value
          if(this.offsetParent.css('position')!=='static') {
            top -= this.offsetParent.offset().top;
          }

          // Set the new absolute top value
          this.el.css({'top': top, 'position': 'absolute'});
        }
        else {
          // We're currently within the scroll window
          if (scrollHeight > this.startingPosition) {
            this.fixToTop();
          }
          // We're above the scroll window
          else {
            this.unfixToTop();
          }
        }
      };

      this.init();
    }

    $(window).on('load',function() {
      $('.fixtop').each(function() {
        var fixtop = new Fixtop($(this));

        $(window).on('scroll',function() {
          raf(function() {
            fixtop.scroll();
          });
        });
      });
    });
  });

  /**** Obscure phone numbers ****/
  $(document).ready(function() {
    $('.fixtelephone').each(function (i,el) {
      el = $(el);
      var phoneMap = {
        'ZERO': '0',
        'ONE': '1',
        'TWO': '2',
        'THREE': '3',
        'FOUR': '4',
        'FIVE': '5',
        'SIX': '6',
        'SEVEN': '7',
        'EIGHT': '8',
        'NINE': '9',
        'DASH': '-'
      };

      var splitOriginalText = el.text().split(" ");
      var phoneNumber = "";
      $.each(splitOriginalText, function(i, num) {
        phoneNumber = phoneNumber.concat(phoneMap[num]);
      });

      el.replaceWith($("<a>").attr('href','tel:'+phoneNumber).text(phoneNumber));
    });
  });

  /**** Obscure email addresses ****/
  $(document).ready(function() {
    $('.fixemail').each(function (i,el) {
      el = $(el);

      //if the href is already a mailto link, just fix the email there
      if (el.tag == 'a' && el.attr('href').substr(0, 7) == 'mailto:') {
        el.attr('href', el.get('href').replace(' AT ', '@').replace(' DOT ', '.'));
        el.text(el.text().replace(' AT ', '@').replace(' DOT ', '.'));

        //remove the fixemail class
        el.removeClass('fixemail');
      }
      else {
        var email = el.text().replace(' AT ', '@').replace(' DOT ', '.');

        el.replaceWith($("<a>").attr('href','mailto:'+email).text(email));
      }
    });
  });

  /**** Form Toggle Buttons ****/
  $(document).on('change','.toggle-switch input', function() {
    if(this.checked) {
      $(this).parent().addClass('checked');
    }
    else {
      $(this).parent().removeClass('checked');
    }
  });
  $(document).on('change','label.button input', function() {
    if(this.checked) {
      $(this).parent().addClass('checked');
      // For radio buttons, trigger 'change' event for all deselected options
      if(this.type === 'radio' && this.name) {
        $('input[type="radio"][name="'+this.name+'"]').each(function() {
          if(!this.checked) {
            $(this).trigger('change');
          }
        });
      }
    }
    else {
      $(this).parent().removeClass('checked');
    }
  });
  // Trigger initial change event
  $(document).ready(function() {
    $('.toggle-switch input:checked, label.button input:checked').trigger('change');
    $('.stepper input[type="number"]').trigger('change');
  });

  /**** Form Numeric Stepper ****/
  $(document).on('change','.stepper input[type="number"]',function(e) {
    var min = $(this).attr('min')*1;
    var max = $(this).attr('max')*1;
    var step = $(this).attr('step')*1||1;
    var value = this.value*1;

    if(value > max) {
      value = max;
      this.value = max;
    }
    else if(value < min) {
      value = min;
      this.value = min;
    }

    this.value = value - value % step;
    value = this.value;


    var stepper = $(this).closest('.stepper');
    var decrement = stepper.find('.decrement');
    var increment = stepper.find('.increment');

    // Disable decrement button when we're already at the minimum value
    if(min !== null && min !== undefined && value <= min) {
      decrement.addClass('disabled');
    }
    else {
      decrement.removeClass('disabled');
    }

    // Disable increment button when we're already at the maximum value
    if(max !== null && max !== undefined && value >= max) {
      increment.addClass('disabled');
    }
    else {
      increment.removeClass('disabled');
    }
  });
  $(document).on('click','.stepper .decrement',function(e) {
    e.preventDefault();
    if($(this).hasClass('disabled')) return;
    var input = $(this).closest('.stepper').find('input');
    var step = $(input).attr('step')*1;
    step = step?step:1;
    input[0].value = input[0].value*1 - step;
    input.trigger('change');
  });
  $(document).on('click','.stepper .increment',function(e) {
    e.preventDefault();
    if($(this).hasClass('disabled')) return;
    var input = $(this).closest('.stepper').find('input');
    var step = $(input).attr('step')*1;
    step = step?step:1;
    input[0].value = input[0].value*1 + step;
    input.trigger('change');
  });

  /**** Floating Form Labels ****/
  var setFloatingLabelClass = function() {
    // Focused or not empty
    var focused = (this === document.activeElement);
    var notEmpty = focused || this.value.length;
    var label = $(this).closest('label');

    if(focused) {
      if(!label.hasClass('focus')) {
        label.addClass('focus');
      }
    }
    else {
      label.removeClass('focus');
    }

    if(notEmpty) {
      if(!label.hasClass('not-empty')) {
        label.addClass('not-empty');
      }
    }
    else {
      label.removeClass('not-empty');
    }
  };
  $(document).on('focus','label.floating :input',setFloatingLabelClass);
  $(document).on('blur','label.floating :input',setFloatingLabelClass);
  $(document).on('change','label.floating :input',setFloatingLabelClass);
  $(document).on('ready',function() {
    $('label.floating :input').each(setFloatingLabelClass);
  });

  /**** Tabs ****/
  var tabClickEvent = function(e) {
    var tabs = $(this).closest('.tabs');

    var containerSelector = tabs.attr('data-target');
    var screenSelector = $(this).attr('data-target');
    if(containerSelector && screenSelector) {
      e.preventDefault();

      // Update 'active' class on the switcher
      $('a',tabs).removeClass('active');
      $(this).addClass('active');

      // Update 'active' class on the content
      var container = $(containerSelector);
      $('> div',container).removeClass('active')
        .filter(screenSelector).addClass('active');
    }
  };
  $(document).on('click','.tabs.overlapped-buttons a',tabClickEvent);
  $(document).on('click','.tabs a',tabClickEvent);

  /**** Inline Dropdowns ****/
  $(document).on('click','.inline-dropdown .toggle',function(e) {
    e.preventDefault();
    var dropdown = $(this).closest('.inline-dropdown');
    if(dropdown.hasClass('open')) {
      dropdown.removeClass('open');
    }
    else {
      // Hide all other open dropdowns
      $('.inline-dropdown.open').removeClass('open');
      dropdown.addClass('open');
    }
  });
  $(document).on('click',function(e) {
    // Clicked on the dropdown toggle, don't do anything
    var t = $(e.target);
    if(t.closest('.inline-dropdown').length && t.closest('.toggle').length) {
      return;
    }

    // Clicked somewhere else on the page, close all open dropdowns
    $('.inline-dropdown.open').removeClass('open');
  });

  /******* custom dropdown ************/
  var uniqueId = (function() {
    var id = 0;
    return function(prefix) {
      if(prefix == null) prefix = 'id';
      id++;
      return prefix + ":" + id;
    };
  })();

  window.Edu.dropdown = function(el) {
    if(!(this instanceof window.Edu.dropdown)) {
      return new window.Edu.dropdown(el);
    }

    this._isOpen = false;
    this._$combobox = $(el);
    this._$listbox = this._$combobox.find('ul:first');
    this._$options = this._$listbox.find('li:not(.disabled)');
    this._$label = this._$combobox.find('.label');
    this._$value = this._$combobox.find('.display-text');
    this._$input = this._$combobox.find('.select-value');
    this._$selected = this._$options.filter('.selected:first');
    this._$focused = null;
    this._init();
  };

  window.Edu.dropdown.prototype = {
    _init: function() {
      // Assign IDs to elements which need them for accessibility references (combobox, listbox, label, pseudovalue)
      this._assignId(this._$combobox);
      this._assignId(this._$listbox);
      this._assignId(this._$label);
      this._assignId(this._$value);

      // Set accessibility attributes
      this._$combobox
        .attr('role', 'combobox')
        .attr('tabindex', 0)
        .attr('aria-autocomplete', 'none')
        .attr('aria-expanded', 'false')
        .attr('aria-owns', this._$listbox.prop('id'))
        .attr('aria-labelledby', [this._$label.prop('id'), this._$value.prop('id')].join(' ').trim());
      this._$listbox
        .attr('role', 'listbox');
      this._$options
        .attr('role', 'option')
        .attr('aria-selected', 'false')
        .attr('tabindex', -1);

      // Initialize selected option (if there is one)
      if(this.value.length > 0) {
        this._select(this._$options.filter('[data-value="'+ this._$input.val() +'"]'));
      }

      // Bind event listeners
      this._$combobox.on('click', this.open.bind(this));
      this._$combobox.on('focusout', this._onFocusOut.bind(this));
      this._$combobox.on('keydown', this._onKeyDown.bind(this));
      this._$options.on('click', function(event) {
        event.stopPropagation();
        this._select($(event.target));
        this.close();
      }.bind(this));

    },

    _onGlobalClick: function(event) {
      if(!$(event.target).closest(this._$combobox).length && this._$combobox.is(':visible')) {
        this.close();
      }
    },

    _onKeyDown: function(event) {
      switch(event.which) {
        case 38: // up
          event.preventDefault();
          !this._isOpen ? this.open() : this.prev();
          break;

        case 40: // down
          event.preventDefault();
          !this._isOpen ? this.open() : this.next();
          break;

        case 36: // home
          if(this._isOpen) {
            event.preventDefault();
            this._focus(this._$options.first());
          }
          break;

        case 35: // end
          if(this._isOpen) {
            event.preventDefault();
            this._focus(this._$options.last());
          }
          break;

        case 32: // space
          event.preventDefault();
          this._activate();
          break;

        case 27: // escape
          this.close();
          break;
      }
    },

    _onFocusOut: function(event) {
      if(!$(event.relatedTarget).closest(this._$combobox).length && this._isOpen) {
        this.close();
      }
    },

    _activate: function() {
      if(this._isOpen) {
        this._select(this._$focused);
        this.close();
      } else {
        this.open();
      }
    },

    _assignId: function($el) {
      return $el.prop('id', $el.prop('id') || uniqueId('edu-dropdown'));
    },

    _select: function($el) {
      this._$selected.attr('aria-selected', 'false');
      this._$selected.removeClass('selected');
      this._$selected = $el;
      this._$selected.attr('aria-selected', 'true');
      this._$selected.addClass('selected');
      this._$value.text($el.text());
      this._$input.val(this._$selected.data('value'));
      this._$combobox.addClass('not-empty');
      this._$combobox.get(0).value = this.value();
      this._$combobox.get(0).dispatchEvent(new Event('change'));
    },

    _focus: function($el) {
      var $old = this._$focused;
      this._$focused = $el || (this._$selected.length ? this._$selected : this._$options.first());
      this._$focused.attr('tabindex', 0);
      this._$focused.get(0).focus();

      if($old != null)
        $old.attr('tabindex', -1);
    },

    next: function() {
      var $next = this._$focused.nextAll('li[role="option"]').first();
      if($next.length !== 1) {
        $next = this._$options.first();
      }
      this._focus($next);
    },

    prev: function() {
      var $prev = this._$focused.prevAll('li[role="option"]').first();
      if($prev.length !== 1) {
        $prev = this._$options.last();
      }
      this._focus($prev);
    },

    open: function() {
      this._isOpen = true;
      this._$listbox.addClass('open');
      this._$combobox.attr('aria-expanded', 'true');
      this._focus();
      $(document).on('click.dropdown', this._onGlobalClick.bind(this));
    },

    close: function() {
      this._isOpen = false;
      this._$listbox.removeClass('open');
      this._$options.attr('tabindex', -1);
      this._$combobox.attr('aria-expanded', 'false');
      this._$combobox.get(0).focus();
      $(document).off('click.dropdown');
    },

    value: function() {
      return this._$input.val();
    }
  };

  $(document).ready(function() {
    $('.custom-dropdown').each(function() {
      window.Edu.dropdown(this);
    });
  });

  /**** Prefix asset urls with the CDN if enabled ****/
  window.Edu.prefixCDN = function(path){
    if(!path) return '';
    if(window.CDNfail) return path;
    var is_absolute = (path.substring(0,7)==='http://' || path.substring(0,8)==='https://');

    // 1. if URL is relative and missing the leading slash, like "assets/something.png", prepend a leading slash
    if ( !is_absolute && path[0] !== '/' ){
      path = '/'+path;
    }

    // 2. check if CDN is enabled. if so:
    //    a. relative paths resolve to cdn+path
    //    b. http(s)://www.education.com+path resolves to cdn+path
    //    c. http(s)://other.domain is not modified
    if(window.Edu.cdn) {
      if (is_absolute) {
        if (path.substring(0, 24) === 'http://www.education.com') {
          path = window.Edu.cdn + path.substring(24);
        } else if (path.substring(0, 25) === 'https://www.education.com') {
          path = window.Edu.cdn + path.substring(25);
        }
      } else {
        path = window.Edu.cdn + path;
      }
    }

    return path;
  };

  /**** Smooth Scroll ****/
  window.Edu.scrollTo = function(el, duration, dir) {
    if(!el.length) return;

    duration = duration || 500;
    dir = dir || 'both';

    var newScrollTop = el.offset().top;

    if(dir === 'up' || dir === 'down') {
      var currentScrollTop = document.body.scrollTop + $('html')[0].scrollTop;
      // Only scrolling up and we're already above the target
      if(dir === 'up' && currentScrollTop <= newScrollTop) {
        return;
      }
      // Only scrolling down and we're already past the target
      else if(dir === 'down' && currentScrollTop >= newScrollTop) {
        return;
      }
    }

    $('html,body').animate({
      scrollTop: newScrollTop
    },duration);
  };
  $(document).on('click','a.smooth-scroll',function(e) {
    // Make sure it's a valid link to an element on the page
    var id = $(this).attr('href');
    if(!id || !id.match(/^#/)) return;
    var target = $(id);
    if(!target.length) return;
    e.preventDefault();
    window.Edu.scrollTo(target);
  });

  /**** Notifications and Member Area ****/
  $(document).ready(function () {
    function MemberSection() {
      // New nav
      if($('header.reorg').length) {
          this.memberNotificationsSelector = 'header.reorg';
          this.memberNotificationsListSelector = '.notifications-list';
          this.enableMemberDropdownToggle = false;
      }
      // Old nav
      else {
          this.memberNotificationsSelector = '.notifications-container';
          this.memberNotificationsListSelector = '.notifications';
          this.enableMemberDropdownToggle = true;
      }

      this.singleMemberNotification = '.notification';
      this.memberDropdownMenuSelector = '.member-dropdown-button';
      this.memberDropdownMenuListSelector = '.dropdown-content';

      this.memberNotificationsContainer = $(this.memberNotificationsSelector);
      this.memberNotificationsTotalContainer = this.memberNotificationsContainer.find('.num-notifications');
      this.memberNotificationsTotal = 0;
      this.memberNotifications = this.memberNotificationsContainer.find(this.memberNotificationsListSelector);
      this.memberNotificationsOpen = false;
      this.memberDropdownMenuContainer = $('.member-dropdown');
      this.memberDropdownMenu = this.memberDropdownMenuContainer.find(this.memberDropdownMenuListSelector);
      this.noNotificationsMessage = 'You don\'t have new notifications.';
      this.memberDropdownOpen = false;
      this.deletedNotificationsVariableName = 'deletedNotifications';
      this.bannersContainer = $('.banner-notifications-container');

      this.loadMemberRegularNotifications = function () {
        var self = this;
        var url = '/api/notifications';
        if(window.location.search.match(/([&?]|^)nocache([&]|$)/)) {
          url += '?nocache';
        }

        $.ajax({
          dataType: 'json',
          method: 'GET',
          url: url,
          data: {
            path: location.pathname[0] == '/' ? location.pathname.substr(1, location.pathname.length-1) : location.pathname
          }
        }).done(function(result) {
          self.memberNotifications.find('.notification').remove();
          if (result.regularNotifications.length > 0) {
            $.each(result.regularNotifications, function (key, notification) {
              var notificationClassName = 'notification-unread font-primary-bold';
              if (notification.status == 1) {
                notificationClassName = 'notification-read';
              }

              // Checking that the notification is removeable
              if (!('removable' in notification) || ('removable' in notification && notification.removable)) {
                  notification.text += '<i class="delete-'+notification.id+' notification-delete icon-cancel-circled2"></i>';
                  $('.delete-all-notifications').show();
              }

              $("<div></div>").html(notification.text)
                .addClass('notificationId-'+notification.id+' notification '+notificationClassName)
                .appendTo(self.memberNotifications);
            });
            self.memberNotificationsTotal = result.regularNotificationsTotal;
            self.updateNotificationsTotalDisplay();
          }
          else {
            $('.delete-all-notifications').hide();
            self.addNoNotificationsMessage(result.total);
          }

          self.bannersContainer.find('.banner-notification').remove();
          if (result.bannerNotifications.length > 0) {
            $.each(result.bannerNotifications, function (key, notification) {
              if (window.Edu.memberId == 0 && self.deletedNotificationInLocalStorage(notification.id)) {
                return true;
              }
              var deleteButtonHtml = '';
              if (notification.removable) {
                deleteButtonHtml = '<i class="delete-'+notification.id+' notification-delete icon-cancel-light"></i>';
              }
              var container = $("<div></div>").html(notification.text)
                .addClass('banner-notification')
                .appendTo(self.bannersContainer);

              container.find('div:first').css('position','relative').append(deleteButtonHtml);
            });
          }
        });
      };

      this.toggleDisplayMemberDropdown = function () {
        this.hideMemberNotifications();
        if (this.memberDropdownOpen) {
          this.memberDropdownOpen = false;
          this.hideMemberDropdown();
        }
        else {
          this.memberDropdownOpen = true;
          this.showMemberDropdown();
        }
      };
      this.toggleDisplayMemberNotifications = function () {
        this.hideMemberDropdown();
        if (this.memberNotificationsOpen) {
          this.hideMemberNotifications();
        }
        else {
          this.showMemberNotifications();
        }
      };
      this.showMemberDropdown = function () {
        this.memberDropdownMenu.css('display', 'inline-block');
      };
      this.updateNotificationsTotalDisplay = function () {
        if (this.memberNotificationsTotal > 0) {
          this.memberNotificationsTotalContainer.html(this.memberNotificationsTotal).addClass('red-bg')
            .css('display', 'inline-block');
        }
        else {
          this.memberNotificationsTotalContainer.css('display', 'none');
        }
      };

      this.hideMemberDropdown = function () {
        this.memberDropdownOpen = false;
        this.memberDropdownMenu.css('display', 'none');
      };
      this.hideMemberNotifications = function () {
        this.memberNotificationsOpen = false;
        this.memberNotifications.css('display', 'none');
      };
      this.showMemberNotifications = function () {
        this.memberNotificationsOpen = true;
        this.memberNotifications.css('display', 'inline-block');
      };

      this.hideAll = function () {
        this.hideMemberDropdown();
        this.hideMemberNotifications();
      };

      this.deleteNotification = function (notification, notificationId) {
        if (notification.hasClass('notification')) {
          this.memberNotificationsTotal--;
          this.updateNotificationsTotalDisplay();
        }
        $('.notificationId-'+notificationId).remove();
      };

      this.deleteAllNotifications = function () {
        this.memberNotificationsTotal = 0;
        this.updateNotificationsTotalDisplay();
        $('.notification').has('.notification-delete').remove();
      };

      this.addNoNotificationsMessage = function () {
        if (!$(this.singleMemberNotification).length) {
          $("<div></div>").appendTo(this.memberNotifications).addClass('notification').text(this.noNotificationsMessage);
        }
      };

      this.deletedNotificationInLocalStorage = function (notificationId) {
        var deletedNotificationInLocalStorage = false;
        try {
          if (window.localStorage) {
            var deletedNotifications = this.getDeletedNotificationsFromLocalStorage();
            $.each(deletedNotifications, function (key, deletedNotificationId) {
              if (notificationId == deletedNotificationId) {
                deletedNotificationInLocalStorage = true;
              }
            });
          }
        }
        catch(e) {}
        return deletedNotificationInLocalStorage;
      };

      this.updateLocalStorageDeletedNotifications = function (notificationId) {
        try {
          if (window.localStorage) {
            var deletedNotifications = this.getDeletedNotificationsFromLocalStorage();
            deletedNotifications.push(notificationId);
            window.localStorage.setItem(this.deletedNotificationsVariableName, JSON.stringify(deletedNotifications));
          }
        }
        catch(e) {}
      };

      this.updateLocalStorageAllDeletedNotifications = function (notificationIds) {
        try {
          if (window.localStorage) {
            var deletedNotifications = this.getDeletedNotificationsFromLocalStorage();
            for (var i = 0; i < notificationIds.length; i++) {
              deletedNotifications.push(notificationIds[i]);
            }

            window.localStorage.setItem(this.deletedNotificationsVariableName, JSON.stringify(deletedNotifications));
          }
        }
        catch(e) {}
      };

      this.getDeletedNotificationsFromLocalStorage = function () {
        try {
          if (window.localStorage) {
            var deletedNotifications = window.localStorage.getItem(this.deletedNotificationsVariableName);
            if (deletedNotifications) {
              deletedNotifications = JSON.parse(deletedNotifications);
            }
            else {
              deletedNotifications = [];
            }

            return deletedNotifications;
          }
        }
        catch(e) {}

        return [];
      };

      /** Makes ajax request that marking the notification as read and redirects if needed */
      this.readNotification = function(el) {
        // Checking that the url exist
        var url = el.getAttribute('data-href');
        if (url) {
          $.ajax({
              dataType: 'json',
              method: 'GET',
              url: url,
              async: false,
              success: function (result) {
                if (result && result.status && result.redirectUrl) {
                  // Checking if there needs to be a new tab opened
                  if (el.getAttribute('target') && el.getAttribute('target') == '_blank') {
                    window.open(result.redirectUrl, '_blank');
                  } else {
                    window.location = result.redirectUrl;
                  }
                }
              }
          });
        }
      };
    }

    var memberSection = new MemberSection();
    memberSection.loadMemberRegularNotifications();

    /**
     * Listener on clicks for the links in the individual notifications and the notification banner
     */
    $(document).on('click', '.notification a, .banner-notifications-container a', function (e) {
        e.preventDefault();
        memberSection.readNotification(this);
    });

    $(document).on('click', '.delete-all-notifications', function(e) {
      e.preventDefault();

      var notifications = $('.notification').has('.notification-delete');
      var notificationIds = [];

      notifications.each(function() {
        notificationIds.push($(this).attr('class').split(' ')[0].split('notificationId-')[1]);
      });

      if (window.Edu.memberId == 0) {
        memberSection.updateLocalStorageAllDeletedNotifications(notificationIds);
      }
      else {
        $.ajax({
          dataType: 'json',
          method: 'POST',
          url: '/api/notification/delete-all'
        });
      }

      var scene = $(this);
      notifications.fadeOut(500, function(){
        memberSection.deleteAllNotifications();
        memberSection.addNoNotificationsMessage();
        scene.fadeOut(250);
      });
    });

    $(document).on('click', '.notification-delete', function (e) {
      e.preventDefault();

      var notificationId = $(this).attr('class').split(' ')[0];
      notificationId = notificationId.split('delete-')[1];

      if (window.Edu.memberId == 0) {
        memberSection.updateLocalStorageDeletedNotifications(notificationId);
      }
      else {
        $.ajax({
          dataType: 'json',
          method: 'POST',
          url: '/api/notification/delete/' + notificationId
        });
      }

      $(this).parent().fadeOut(500, function(){
        memberSection.deleteNotification($(this), notificationId);
        memberSection.addNoNotificationsMessage();
      });
    });

    if(memberSection.enableMemberDropdownToggle) {
        $(document).on('click', function (e) {
            if ($(e.target).parents(memberSection.memberDropdownMenuSelector).length) {
                if (!$(e.target).parents(memberSection.memberDropdownMenuListSelector).length) {
                    memberSection.toggleDisplayMemberDropdown();
                }
            }
            else if ($(e.target).parents(memberSection.memberNotificationsSelector).length) {
                if (!$(e.target).parents(memberSection.memberNotificationsListSelector).length) {
                    memberSection.toggleDisplayMemberNotifications();
                }
            }
            else {
                memberSection.hideAll();
            }
        });
    }
  });


  /**** Collections ****/
  window.Edu.Collectible = (function(){
    var collectibleContent = {};
    var fetchedCollections = false;
    var collectionId = 'pending';
    var collections = [];
    var pendingItem = null;
    var timeout = null;

    var populate = function() {
      collectibleContent = {};
      $('.content-result:not(.in-collection-tray):not([data-collectible="0"])').each(function() {
        populateItem(this);
      });
      $('.collectible-content-item.inline:not([data-collectible="0"])').each(function() {
        populateItem(this);
      });
    }
    var populateItem = function(el) {
      var $a, type, id, title, thumbnail;
      $a = $(el).children('a').first();
      var elementType = $(el).hasClass('inline') ? 'inline' : 'content-card';
      if(elementType==='content-card') {
        type = $a.attr('data-type');
        id = $a.attr('data-id');
        title = $(el).find('.title').first().find('span').first().html() || $(el).find('.title').first().html();
        thumbnail = $(el).find('.image').first().find('img').first().attr('src');
      } else {
        elementType = 'inline';
        type = $(el).attr('data-type');
        id = $(el).attr('data-id');
        title = $(el).attr('data-title');
        thumbnail = $(el).attr('data-thumbnail');
      }
      var collectedIn = [];

      if (type && id) {
        for(var cid in collections){
          var collection = collections[cid];
          if(collection.content) {
            for (var key in collection.content) {
              var item = collection.content[key];
              if(item.type===type && item.id===id){
                collectedIn.push(cid);
              }
            }
          }
        }
        collectibleContent[type+'|'+id] = {id: id, type: type, el: el, collectedIn: collectedIn};

        $('#collections').removeClass('hidden');
        fetchCollections();

        if(elementType==='content-card') {
          $(el).append(
            '<div class="collectible-content-item">\
              <div class="btn btn-tertiary btn-round btn-collect' + (collectedIn.length?' selected':'') + '" data-id="' + id + '" data-type="' + type + '" data-title="' + title + '" data-thumbnail="' + thumbnail + '">\
                <i class="icon-bookmark"></i>\
                <i class="icon-bookmark-filled"></i>\
              </div>\
            </div>'
          );
          $(el).addClass('collectible-content');
        } else if(elementType==='inline') {
          $(el).html(
            '<a class="btn-collect' + (collectedIn.length?' selected':'') + ($(el).attr('data-classes')?' '+$(el).attr('data-classes'):'')+'" data-id="' + id + '" data-type="' + type + '" data-title="' + title + '" data-thumbnail="' + thumbnail + '">\
              <i class="icon-bookmark"></i>\
              <i class="icon-bookmark-filled"></i>\
              <span class="add-to-collection">Add to collection</span>\
              <span class="added-to-collection">Added to collection</span>\
            </a>'
          );
        }
      }
    }
    var renderCollectible = function(item, classes){
      classes = classes || "";
      return '<div class="content-result in-collection-tray'+(classes?' '+classes:'')+'" data-id="'+item.id+'" data-type="'+item.type+'">\
                <i class="icon-trash-light btn-round" data-id="'+item.id+'" data-type="'+item.type+'"></i>\
                <div class="content-result-link">\
                  <div class="front-section">\
                    <div class="image">\
                      <img src="'+item.thumbnail+'">\
                    </div>\
                    <div class="content-title">\
                      <div class="font-primary-bold title"><span>'+item.title+'</span></div>\
                      <div class="content-type"><div class="content-type-name">'+item.type+'</div></div>\
                    </div>\
                  </div>\
                </div>\
              </div>';
    };
    var clickClose = function() {
      if(collectionId==='pending'){
        if($('#collections').hasClass('page-new-collection')){
          toPage('choose-collection');
        } else {
          $('#collections').removeClass('active');
          if(!collectibleContent[pendingItem.type+'|'+pendingItem.id] || (collectibleContent[pendingItem.type+'|'+pendingItem.id] && Object.keys(collectibleContent[pendingItem.type+'|'+pendingItem.id].collectedIn).length===0) ) {
            $('.btn-collect.selected[data-id=' + pendingItem.id + '][data-type=' + pendingItem.type + ']').removeClass('selected');
          }
          pendingItem = null;
        }
      } else {
        toPage('collection');
      }
    }
    var clickCollect = function() {
      if(window.Edu && window.Edu.accountType==="Anonymous") {
        $('#collections-featurewall').modal('show');
        return;
      }

      var type = $(this).attr('data-type');
      var id = $(this).attr('data-id');
      var title = $(this).attr('data-title');
      var thumbnail = $(this).attr('data-thumbnail');

      var key = type+'|'+id;
      var item = {id: id, type: type, title: title, thumbnail: thumbnail};

      if (collectionId==='pending') {
        pendingItem = item;
        $(this).addClass('selected');
        toPage('choose-collection');
      } else {
        if(!(key in collections[collectionId].content)) {
          var resp = addToCollection(item);
          if(resp) {
            $(this).addClass('selected');
          }
        } else {
          removeFromCollection(item);
        }
      }
      $('#collections').addClass('active');
    }

    var addToCollection = function(item) {
      if(Object.keys(collections[collectionId].content).length >= 50){
        $('#collections .error').removeClass('inactive').html("This collection is full");
        clearTimeout(timeout);
        timeout = setTimeout(function(){
          $('#collections .error').addClass('inactive').html("");
        }, 5000);
        return false;
      }
      var key = item.type + '|' + item.id;
      collections[collectionId].content[key] = item;
      var count = Object.keys(collections[collectionId].content).length;
      $('#collections .collection .count').addClass('animate').html(count);
      setTimeout(function(){
        $('#collections .collection .count').removeClass('animate');
      }, 250);
      $('#collections .collection .count-label').html((count>1||count==0)?'items':'item');
      $('#collections .collection .right').prepend(renderCollectible(item, 'added'));
      $('#collections .content-result').on('click', '.icon-trash-light', function(){
        removeFromCollection({id: $(this).attr('data-id'), type: $(this).attr('data-type')});
      });
      if(count<=1) {
        $('#collections .collection').removeClass('minimized');
      }
      collectibleContent[item.type+'|'+item.id].collectedIn.push(collectionId);
      $.ajax({url: '/api/collections/addToMemberCollection', method: 'post', data: {
        collectionId: collectionId,
        content: [{id: item.id, type: item.type}]
      }}).done(function(data){
        if(window.Edu && window.Edu.trackEvent) {
          window.Edu.trackEvent('Added to collection', {}, {
            eventCategory: "Collections",
            eventAction: "Added to collection"
          });
        }
        // console.log(data);
      });
      return true;
    }

    var removeFromCollection = function(item) {
      var key = item.type + '|' + item.id;
      delete collections[collectionId].content[key];
      var count = Object.keys(collections[collectionId].content).length;
      $('#collections .collection .count').addClass('animate').html(count);
      setTimeout(function(){
        $('#collections .collection .count').removeClass('animate');
      }, 250);
      $('#collections .collection .count-label').html((count>1||count==0)?'items':'item');
      var $itemEl = $('#collections .collection .right .content-result[data-id='+item.id+'][data-type='+item.type+']');
      $itemEl.removeClass('added').addClass('removed');
      setTimeout(function() {
        $itemEl.remove();
      }, 250);
      if( (item.type+'|'+item.id) in collectibleContent && collectibleContent[item.type+'|'+item.id].collectedIn) {
        var collectedInIndex = collectibleContent[item.type + '|' + item.id].collectedIn.indexOf(collectionId);
        if (collectedInIndex !== -1) {
          collectibleContent[item.type + '|' + item.id].collectedIn.splice(collectedInIndex, 1);
          if (!(collectibleContent[item.type + '|' + item.id].collectedIn.length)) {
            $('.btn-collect[data-id=' + item.id + '][data-type=' + item.type + ']').removeClass('selected');
          }
        }
      }
      $.ajax({url: '/api/collections/removeFromMemberCollection', method: 'post', data: {
        collectionId: collectionId,
        content: [{id: item.id, type: item.type}]
      }}).done(function(data){
        // console.log(data);
      });
    }

    var submitNewCollection = function() {
      var collectionTitle = $('#collections .new-collection input[name=title]').val().trim();
      $('#collections .new-collection input[name=title]').val(collectionTitle);
      if(collectionTitle!=="") {
        $('#collections .new-collection .btn-save').addClass('disabled');
        var postData = {title: collectionTitle};
        $.ajax({url: '/api/collections/createCollection', method: 'post', data: postData})
        .done(function(data){
          if(data.status) {
            $('#collections .new-collection .btn-save').removeClass('disabled');
            $('#collections .new-collection input[name=title]').val("");
            collectionId = data.collection.id;
            if (data.collection && data.collection.id) {
              collections[data.collection.id] = data.collection;
              $('#collections .choose-collection .list').append(
                '<div class="item" data-id="' + data.collection.id + '">\
                <div class="icon" style="background-image: url(' + window.Edu.prefixCDN(data.collection.thumbnail) + ')"></div>\
                <div class="label">' + data.collection.title + '</div>\
              </div>'
              );
              var count = Object.keys(collections[collectionId].content).length;
              $('#collections .collection .count').html(count);
              $('#collections .collection .count-label').html((count > 1 || count == 0) ? 'items' : 'item');
              $('#collections .collection .right').html("");
            }
            if(window.Edu && window.Edu.trackEvent) {
              window.Edu.trackEvent('Created new collection', {}, {
                eventCategory: "Collections",
                eventAction: "Created new collection"
              });
            }
            toPage('collection', ($(window).width()>600)?true:false);
          } else {
            $('#collections .new-collection .btn-save').removeClass('disabled');
            console.log('failed create collection', data);
            $('#collections .error').removeClass('inactive').html(data.error.message || "Cannot create collection");
            clearTimeout(timeout);
            timeout = setTimeout(function(){
              $('#collections .error').addClass('inactive').html("");
            }, 5000);
          }
        }).fail(function(){
          $('#collections .new-collection .btn-save').removeClass('disabled');
          console.log('failed create collection', data);
          $('#collections .error').removeClass('inactive').html("Cannot create collection");
          clearTimeout(timeout);
          timeout = setTimeout(function(){
            $('#collections .error').addClass('inactive').html("");
          }, 5000);
        });
      }
    }

    var setCollection = function(c) {
      collectionId = c;
    }

    var toPage = function(page, startMaximized) {
      startMaximized = startMaximized || false;
      $('#collections').removeClass('page-collection page-choose-collection page-new-collection').addClass('page-'+page);
      if(page==='collection'){
        $('#collections').addClass('active');
        if(startMaximized) {
          $('#collections .collection').removeClass('minimized');
        }
        $('#collections .collection .title a').html(collections[collectionId].title);
        $('#collections .collection .full .title a').attr('href', '/my/collections/'+collections[collectionId].url);
        var count = Object.keys(collections[collectionId].content).length;
        $('#collections .collection .count').html(count);
        $('#collections .collection .count-label').html((count>1||count==0)?'items':'item');
        $('#collections .collection .right').html('');
        if(collectionId in collections){
          for(var key in collections[collectionId].content){
            var item = collections[collectionId].content[key];
            $('#collections .collection .right').append(renderCollectible(item));
          }
          $('#collections .content-result').on('click', '.icon-trash-light', function(){
            removeFromCollection({id: $(this).attr('data-id'), type: $(this).attr('data-type')});
          });
        }
        if(pendingItem && pendingItem.id && pendingItem.type){
          addToCollection(pendingItem);
          pendingItem = null;
        }
      }
    };

    var fetchCollections = function() {
      // only fetch if we haven't fetched yet
      if(fetchedCollections) return;

      // only fetch if there is collectible content on the page
      if(Object.keys(collectibleContent).length) {
        fetchedCollections = true;
        $.ajax({url: '/api/collections/memberCollections'})
          .done(function (data) {
            if (data.collections && data.contentModels) {
              collections = data.collections;
              for (var cid in collections) {
                for (var contentId in collections[cid].content) {
                  collections[cid].content[contentId] = $.extend(true, {}, collections[cid].content[contentId], data.contentModels[contentId]);
                }
                $('#collections .choose-collection .list').append(
                  '<div class="item" data-id="' + cid + '">\
                    <div class="icon'+(!(collections[cid].thumbnail) ? " empty" : "")+'" style="background-image: url(' + window.Edu.prefixCDN(collections[cid].thumbnail) + ')">\
                    '+(!(collections[cid].thumbnail) ? "Empty" : "")+'\
                    </div>\
                    <div class="label"><span>' + collections[cid].title + '</span></div>\
                  </div>'
                );
              }
              populate();
            }
            var now = data.now;
            var dateUpdated = data.dateUpdated || now;
            var recency = ( (new Date(now)).valueOf() - (new Date(dateUpdated)).valueOf() )/1000;
            // console.log(recency, now, dateUpdated);
            if (recency<(3*3600) && data.currentCollection) {       // exists and is within 3 hour session
              collectionId = data.currentCollection;
              toPage('collection');
            } else {
              collectionId = "pending";
              toPage('choose-collection');
            }
            $('.collectible-content-item.inline').removeClass('disabled');
          })
          .fail(function () {
            fetchedCollections = false;
            console.log('failed collection fetch');
          });
      }
    };

    var init = function() {
      // if anonymous, skip the fetchCollections call:
      if(window.Edu && window.Edu.accountType==="Anonymous") {
        fetchedCollections = true;
      }

      populate();
      $(window).on('renderContentCards', populate);
      if(!Object.keys(collectibleContent).length) {
        $('#collections').addClass('hidden');
      } else {
        $('#collections').removeClass('hidden');
      }
      if($(window).width()<=600) {
        $('#collections .collection').addClass('minimized');
      }
      $(document).on('click', '.btn-collect', clickCollect);
      $('#collections .choose-collection .icon-cancel-light').click(clickClose);
      $('#collections .new-collection .icon-cancel-light').click(clickClose);
      $('#collections .new-collection .btn-cancel').click(clickClose);
      $('#collections .overlay-back').click(clickClose);
      $('#collections .collection .btn-minimize').click(function(){
        $('#collections .collection').addClass('minimized');
      });
      $('#collections .collection .ribbon').click(function(){
        $('#collections .collection').removeClass('minimized');
      });
      $('#collections .collection .btn-change-collection').click(function(){
        $('#collections .choose-collection .title').html('Choose collection');
        toPage('choose-collection');
      });
      $('#collections .choose-collection .list').on('click', '.item', function(){
        collectionId = $(this).attr('data-id');
        toPage('collection', ($(window).width()>600)?true:false);
      });
      $('#collections .choose-collection').on('click', '.item.new', function(){
        toPage('new-collection');
      });
      $('#collections .new-collection .btn-save').click(submitNewCollection);

      // Fetch the user's collections before showing anything
      fetchCollections();
    };

    return {
      init: init,
      populate: populate,
      populateItem: populateItem,
      clickCollect: clickCollect,
      setCollection: setCollection
    }
  })();

  $(document).ready(function() {
    window.Edu.Collectible.init();
  });



  $(document).on('click', '.messagestack .close-message', function () {
    $(this).parents('.messagestack-message').fadeOut('slow', function() {});
  });

  $(document).ready(function () {
    function FilterScroll () {
      this.scrollContainers = $('.filter-scroll-container');
      this.scrollNav = $('.filter-scroll-nav');
      this.updateSelected = function () {
        for(var i = 0; i < this.scrollContainers.length; i++) {
          var viewportYPosition = $(window).scrollTop() + parseInt($(this.scrollContainers[i]).attr('data-top-margin'));

          if (viewportYPosition > $(this.scrollContainers[i]).offset().top) {
            this.scrollNav.find('.filter-scroll-selected').removeClass('filter-scroll-selected');
            $('.filter-scroll-index-'+i).addClass('filter-scroll-selected');
          }
        }
      };
    }

    if ('.filter-scroll-container'.length > 0) {
      var filterScroll = new FilterScroll();

      $(window).scroll(function() {
        filterScroll.updateSelected();
      });
    }
  });
  /**
   * @preserve FastClick: polyfill to remove click delays on browsers with touch UIs.
   *
   * @codingstandard ftlabs-jsv2
   * @copyright The Financial Times Limited [All Rights Reserved]
   * @license MIT License (see LICENSE.txt)
   */
  !function(){"use strict";function t(e,o){function i(t,e){return function(){return t.apply(e,arguments)}}var r;if(o=o||{},this.trackingClick=!1,this.trackingClickStart=0,this.targetElement=null,this.touchStartX=0,this.touchStartY=0,this.lastTouchIdentifier=0,this.touchBoundary=o.touchBoundary||10,this.layer=e,this.tapDelay=o.tapDelay||200,this.tapTimeout=o.tapTimeout||700,!t.notNeeded(e)){for(var a=["onMouse","onClick","onTouchStart","onTouchMove","onTouchEnd","onTouchCancel"],c=this,s=0,u=a.length;u>s;s++)c[a[s]]=i(c[a[s]],c);n&&(e.addEventListener("mouseover",this.onMouse,!0),e.addEventListener("mousedown",this.onMouse,!0),e.addEventListener("mouseup",this.onMouse,!0)),e.addEventListener("click",this.onClick,!0),e.addEventListener("touchstart",this.onTouchStart,!1),e.addEventListener("touchmove",this.onTouchMove,!1),e.addEventListener("touchend",this.onTouchEnd,!1),e.addEventListener("touchcancel",this.onTouchCancel,!1),Event.prototype.stopImmediatePropagation||(e.removeEventListener=function(t,n,o){var i=Node.prototype.removeEventListener;"click"===t?i.call(e,t,n.hijacked||n,o):i.call(e,t,n,o)},e.addEventListener=function(t,n,o){var i=Node.prototype.addEventListener;"click"===t?i.call(e,t,n.hijacked||(n.hijacked=function(t){t.propagationStopped||n(t)}),o):i.call(e,t,n,o)}),"function"==typeof e.onclick&&(r=e.onclick,e.addEventListener("click",function(t){r(t)},!1),e.onclick=null)}}var e=navigator.userAgent.indexOf("Windows Phone")>=0,n=navigator.userAgent.indexOf("Android")>0&&!e,o=/iP(ad|hone|od)/.test(navigator.userAgent)&&!e,i=o&&/OS 4_\d(_\d)?/.test(navigator.userAgent),r=o&&/OS [6-7]_\d/.test(navigator.userAgent),a=navigator.userAgent.indexOf("BB10")>0;t.prototype.needsClick=function(t){switch(t.nodeName.toLowerCase()){case"button":case"select":case"textarea":if(t.disabled)return!0;break;case"input":if(o&&"file"===t.type||t.disabled)return!0;break;case"label":case"iframe":case"video":return!0}return/\bneedsclick\b/.test(t.className)},t.prototype.needsFocus=function(t){switch(t.nodeName.toLowerCase()){case"textarea":return!0;case"select":return!n;case"input":switch(t.type){case"button":case"checkbox":case"file":case"image":case"radio":case"submit":return!1}return!t.disabled&&!t.readOnly;default:return/\bneedsfocus\b/.test(t.className)}},t.prototype.sendClick=function(t,e){var n,o;document.activeElement&&document.activeElement!==t&&document.activeElement.blur(),o=e.changedTouches[0],n=document.createEvent("MouseEvents"),n.initMouseEvent(this.determineEventType(t),!0,!0,window,1,o.screenX,o.screenY,o.clientX,o.clientY,!1,!1,!1,!1,0,null),n.forwardedTouchEvent=!0,t.dispatchEvent(n)},t.prototype.determineEventType=function(t){return n&&"select"===t.tagName.toLowerCase()?"mousedown":"click"},t.prototype.focus=function(t){var e;o&&t.setSelectionRange&&0!==t.type.indexOf("date")&&"time"!==t.type&&"month"!==t.type?(e=t.value.length,t.setSelectionRange(e,e)):t.focus()},t.prototype.updateScrollParent=function(t){var e,n;if(e=t.fastClickScrollParent,!e||!e.contains(t)){n=t;do{if(n.scrollHeight>n.offsetHeight){e=n,t.fastClickScrollParent=n;break}n=n.parentElement}while(n)}e&&(e.fastClickLastScrollTop=e.scrollTop)},t.prototype.getTargetElementFromEventTarget=function(t){return t.nodeType===Node.TEXT_NODE?t.parentNode:t},t.prototype.onTouchStart=function(t){var e,n,r;if(t.targetTouches.length>1)return!0;if(e=this.getTargetElementFromEventTarget(t.target),n=t.targetTouches[0],o){if(r=window.getSelection(),r.rangeCount&&!r.isCollapsed)return!0;if(!i){if(n.identifier&&n.identifier===this.lastTouchIdentifier)return t.preventDefault(),!1;this.lastTouchIdentifier=n.identifier,this.updateScrollParent(e)}}return this.trackingClick=!0,this.trackingClickStart=t.timeStamp,this.targetElement=e,this.touchStartX=n.pageX,this.touchStartY=n.pageY,t.timeStamp-this.lastClickTime<this.tapDelay&&t.preventDefault(),!0},t.prototype.touchHasMoved=function(t){var e=t.changedTouches[0],n=this.touchBoundary;return Math.abs(e.pageX-this.touchStartX)>n||Math.abs(e.pageY-this.touchStartY)>n?!0:!1},t.prototype.onTouchMove=function(t){return this.trackingClick?((this.targetElement!==this.getTargetElementFromEventTarget(t.target)||this.touchHasMoved(t))&&(this.trackingClick=!1,this.targetElement=null),!0):!0},t.prototype.findControl=function(t){return void 0!==t.control?t.control:t.htmlFor?document.getElementById(t.htmlFor):t.querySelector("button, input:not([type=hidden]), keygen, meter, output, progress, select, textarea")},t.prototype.onTouchEnd=function(t){var e,a,c,s,u,l=this.targetElement;if(!this.trackingClick)return!0;if(t.timeStamp-this.lastClickTime<this.tapDelay)return this.cancelNextClick=!0,!0;if(t.timeStamp-this.trackingClickStart>this.tapTimeout)return!0;if(this.cancelNextClick=!1,this.lastClickTime=t.timeStamp,a=this.trackingClickStart,this.trackingClick=!1,this.trackingClickStart=0,r&&(u=t.changedTouches[0],l=document.elementFromPoint(u.pageX-window.pageXOffset,u.pageY-window.pageYOffset)||l,l.fastClickScrollParent=this.targetElement.fastClickScrollParent),c=l.tagName.toLowerCase(),"label"===c){if(e=this.findControl(l)){if(this.focus(l),n)return!1;l=e}}else if(this.needsFocus(l))return t.timeStamp-a>100||o&&window.top!==window&&"input"===c?(this.targetElement=null,!1):(this.focus(l),this.sendClick(l,t),o&&"select"===c||(this.targetElement=null,t.preventDefault()),!1);return o&&!i&&(s=l.fastClickScrollParent,s&&s.fastClickLastScrollTop!==s.scrollTop)?!0:(this.needsClick(l)||(t.preventDefault(),this.sendClick(l,t)),!1)},t.prototype.onTouchCancel=function(){this.trackingClick=!1,this.targetElement=null},t.prototype.onMouse=function(t){return this.targetElement?t.forwardedTouchEvent?!0:t.cancelable&&(!this.needsClick(this.targetElement)||this.cancelNextClick)?(t.stopImmediatePropagation?t.stopImmediatePropagation():t.propagationStopped=!0,t.stopPropagation(),t.preventDefault(),!1):!0:!0},t.prototype.onClick=function(t){var e;return this.trackingClick?(this.targetElement=null,this.trackingClick=!1,!0):"submit"===t.target.type&&0===t.detail?!0:(e=this.onMouse(t),e||(this.targetElement=null),e)},t.prototype.destroy=function(){var t=this.layer;n&&(t.removeEventListener("mouseover",this.onMouse,!0),t.removeEventListener("mousedown",this.onMouse,!0),t.removeEventListener("mouseup",this.onMouse,!0)),t.removeEventListener("click",this.onClick,!0),t.removeEventListener("touchstart",this.onTouchStart,!1),t.removeEventListener("touchmove",this.onTouchMove,!1),t.removeEventListener("touchend",this.onTouchEnd,!1),t.removeEventListener("touchcancel",this.onTouchCancel,!1)},t.notNeeded=function(t){var e,o,i,r;if("undefined"==typeof window.ontouchstart)return!0;if(o=+(/Chrome\/([0-9]+)/.exec(navigator.userAgent)||[,0])[1]){if(!n)return!0;if(e=document.querySelector("meta[name=viewport]")){if(-1!==e.content.indexOf("user-scalable=no"))return!0;if(o>31&&document.documentElement.scrollWidth<=window.outerWidth)return!0}}if(a&&(i=navigator.userAgent.match(/Version\/([0-9]*)\.([0-9]*)/),i[1]>=10&&i[2]>=3&&(e=document.querySelector("meta[name=viewport]")))){if(-1!==e.content.indexOf("user-scalable=no"))return!0;if(document.documentElement.scrollWidth<=window.outerWidth)return!0}return"none"===t.style.msTouchAction||"manipulation"===t.style.touchAction?!0:(r=+(/Firefox\/([0-9]+)/.exec(navigator.userAgent)||[,0])[1],r>=27&&(e=document.querySelector("meta[name=viewport]"),e&&(-1!==e.content.indexOf("user-scalable=no")||document.documentElement.scrollWidth<=window.outerWidth))?!0:"none"===t.style.touchAction||"manipulation"===t.style.touchAction?!0:!1)},t.attach=function(e,n){return new t(e,n)},"function"==typeof define&&"object"==typeof define.amd&&define.amd?define(function(){return t}):"undefined"!=typeof module&&module.exports?(module.exports=t.attach,module.exports.FastClick=t):window.FastClick=t}();

  /*!
   * jQuery Cookie Plugin v1.4.1
   * https://github.com/carhartl/jquery-cookie
   *
   * Copyright 2006, 2014 Klaus Hartl
   * Released under the MIT license
   */
  !function(e){"function"==typeof define&&define.amd?define(["jquery"],e):e("object"==typeof exports?require("jquery"):jQuery)}(function(e){function n(e){return u.raw?e:encodeURIComponent(e)}function o(e){return u.raw?e:decodeURIComponent(e)}function i(e){return n(u.json?JSON.stringify(e):String(e))}function r(e){0===e.indexOf('"')&&(e=e.slice(1,-1).replace(/\\"/g,'"').replace(/\\\\/g,"\\"));try{return e=decodeURIComponent(e.replace(c," ")),u.json?JSON.parse(e):e}catch(n){}}function t(n,o){var i=u.raw?n:r(n);return e.isFunction(o)?o(i):i}var c=/\+/g,u=e.cookie=function(r,c,a){if(arguments.length>1&&!e.isFunction(c)){if(a=e.extend({},u.defaults,a),"number"==typeof a.expires){var f=a.expires,s=a.expires=new Date;s.setTime(+s+864e5*f)}return document.cookie=[n(r),"=",i(c),a.expires?"; expires="+a.expires.toUTCString():"",a.path?"; path="+a.path:"",a.domain?"; domain="+a.domain:"",a.secure?"; secure":""].join("")}for(var d=r?void 0:{},p=document.cookie?document.cookie.split("; "):[],m=0,x=p.length;x>m;m++){var l=p[m].split("="),g=o(l.shift()),k=l.join("=");if(r&&r===g){d=t(k,c);break}r||void 0===(k=t(k))||(d[g]=k)}return d};u.defaults={},e.removeCookie=function(n,o){return void 0===e.cookie(n)?!1:(e.cookie(n,"",e.extend({},o,{expires:-1})),!e.cookie(n))}});

  // Load Promise polyfill
  !function(e,n){"object"==typeof exports&&"undefined"!=typeof module?n():"function"==typeof define&&define.amd?define(n):n()}(0,function(){"use strict";function e(e){var n=this.constructor;return this.then(function(t){return n.resolve(e()).then(function(){return t})},function(t){return n.resolve(e()).then(function(){return n.reject(t)})})}function n(){}function t(e){if(!(this instanceof t))throw new TypeError("Promises must be constructed via new");if("function"!=typeof e)throw new TypeError("not a function");this._state=0,this._handled=!1,this._value=undefined,this._deferreds=[],u(e,this)}function o(e,n){for(;3===e._state;)e=e._value;0!==e._state?(e._handled=!0,t._immediateFn(function(){var t=1===e._state?n.onFulfilled:n.onRejected;if(null!==t){var o;try{o=t(e._value)}catch(f){return void i(n.promise,f)}r(n.promise,o)}else(1===e._state?r:i)(n.promise,e._value)})):e._deferreds.push(n)}function r(e,n){try{if(n===e)throw new TypeError("A promise cannot be resolved with itself.");if(n&&("object"==typeof n||"function"==typeof n)){var o=n.then;if(n instanceof t)return e._state=3,e._value=n,void f(e);if("function"==typeof o)return void u(function(e,n){return function(){e.apply(n,arguments)}}(o,n),e)}e._state=1,e._value=n,f(e)}catch(r){i(e,r)}}function i(e,n){e._state=2,e._value=n,f(e)}function f(e){2===e._state&&0===e._deferreds.length&&t._immediateFn(function(){e._handled||t._unhandledRejectionFn(e._value)});for(var n=0,r=e._deferreds.length;r>n;n++)o(e,e._deferreds[n]);e._deferreds=null}function u(e,n){var t=!1;try{e(function(e){t||(t=!0,r(n,e))},function(e){t||(t=!0,i(n,e))})}catch(o){if(t)return;t=!0,i(n,o)}}var c=setTimeout;t.prototype["catch"]=function(e){return this.then(null,e)},t.prototype.then=function(e,t){var r=new this.constructor(n);return o(this,new function(e,n,t){this.onFulfilled="function"==typeof e?e:null,this.onRejected="function"==typeof n?n:null,this.promise=t}(e,t,r)),r},t.prototype["finally"]=e,t.all=function(e){return new t(function(n,t){function o(e,f){try{if(f&&("object"==typeof f||"function"==typeof f)){var u=f.then;if("function"==typeof u)return void u.call(f,function(n){o(e,n)},t)}r[e]=f,0==--i&&n(r)}catch(c){t(c)}}if(!e||"undefined"==typeof e.length)throw new TypeError("Promise.all accepts an array");var r=Array.prototype.slice.call(e);if(0===r.length)return n([]);for(var i=r.length,f=0;r.length>f;f++)o(f,r[f])})},t.resolve=function(e){return e&&"object"==typeof e&&e.constructor===t?e:new t(function(n){n(e)})},t.reject=function(e){return new t(function(n,t){t(e)})},t.race=function(e){return new t(function(n,t){for(var o=0,r=e.length;r>o;o++)e[o].then(n,t)})},t._immediateFn="function"==typeof setImmediate&&function(e){setImmediate(e)}||function(e){c(e,0)},t._unhandledRejectionFn=function(e){void 0!==console&&console&&console.warn("Possible Unhandled Promise Rejection:",e)};var l=function(){if("undefined"!=typeof self)return self;if("undefined"!=typeof window)return window;if("undefined"!=typeof global)return global;throw Error("unable to locate global object")}();"Promise"in l?l.Promise.prototype["finally"]||(l.Promise.prototype["finally"]=e):l.Promise=t});


    $(document).ajaxSend(function(event, jqXHR, ajaxOptions) {
    if (window.jQuery.inArray(ajaxOptions.type.toLowerCase(), ['post','put','patch','delete']) !== -1 && ajaxOptions.url.substring(0,5).toLowerCase() === '/api/') {
      jqXHR.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
      if (ajaxOptions.data && ajaxOptions.data.length) {
        ajaxOptions.data += '&'+window.jQuery.param({csrfToken: window.Edu.csrfToken});
      } else {
        ajaxOptions.data = window.jQuery.param({csrfToken: window.Edu.csrfToken});
      }
    }
  });

  /** Fix for when the session has expired */
  $(document).ajaxComplete(function(event, xhr, settings) {
    if (!('expiredSessionRefresh' in window.Edu.queryString)) {
      if (xhr && xhr.status === 403 && settings && settings.type === 'POST') {
        if ('expiredSessionRefresh' in xhr.responseJSON) {
          var refreshUrl = window.location.href;
          if (window.Edu.queryString.length) {
              refreshUrl += '&expiredSessionRefresh=true';
          } else {
              refreshUrl += '?expiredSessionRefresh=true';
          }
          window.location = refreshUrl;
        }
      }
    }
  });
})(window.jQuery||window.Zepto);

